import { GetInferredFromRaw } from '@thinknimble/tn-models'
import { z } from 'zod'

/** Read shape for listing/retrieving the caller's personal access tokens. Never includes the raw secret. */
export const userTokenShape = {
  id: z.string().uuid(),
  name: z.string(),
  prefix: z.string(),
  permissions: z.array(z.string()),
  /** Intersection of the token's grant and the owner's current role permissions. */
  effectivePermissions: z.array(z.string()),
  expiresAt: z.string().datetime().nullable(),
  lastUsedAt: z.string().datetime().nullable(),
  created: z.string().datetime(),
}

/** Input shape for minting a user token. */
export const createUserTokenShape = {
  name: z.string(),
  permissions: z.array(z.string()),
  expiresAt: z.string().datetime().nullable().optional(),
}

/**
 * Response shape for a freshly minted user token. The raw `token` secret is
 * only ever returned once, at creation time.
 */
export const userTokenCreatedShape = {
  id: z.string().uuid(),
  name: z.string(),
  token: z.string(),
  permissions: z.array(z.string()),
  expiresAt: z.string().datetime().nullable(),
  created: z.string().datetime(),
}

export type UserToken = GetInferredFromRaw<typeof userTokenShape>
export type CreateUserToken = GetInferredFromRaw<typeof createUserTokenShape>
export type UserTokenCreated = GetInferredFromRaw<typeof userTokenCreatedShape>
